import React, { useState } from 'react';
import { b64EncodeUnicode } from '../utils/Tools';
import { handleBundleCheckboxClick } from '../utils/BundleUtils';
import { ReactComponent as Check } from '../assets/check.svg';
import Lightbox from 'react-simple-lightbox';
import intl from 'react-intl-universal';
import '../styles/components/BundleItemListExtended.scss';

const BundleItemListExtended = ({
	product,
	parent,
	groupTreshold,
	toggleConfirmButton,
	showBarcodeInPackingZone,
	currentIndex,
}) => {
	const { product_confirmation_method, scan_bundle_element_as_single_qty, bundle_select } = parent.props;
	let product_uom_qty = product.product_uom_qty;
	if (product.product_uom_qty < groupTreshold) {
		product_uom_qty = 1;
	}
	const odoo = window.ODOO.url + (window.ODOO.port ? ':' + window.ODOO.port : '') + '/product/image?default_code=';
	return (
		<div className={`ramka bundleItemList${bundle_select ? ' locked' : ''}`}>
			{product.items.map((item, index) => {
				const barcodeString =
					'#' +
					(item.barcode || '') +
					'#' +
					(item.additional_barcodes_ids || []).map(item => (typeof item === 'object' ? item.barcode : item)).join('#') +
					'#';
				const destinationQty = product_uom_qty * item.qty_uom;
				return (
					<div
						className='bundleItemExtended bundleItem'
						data-barcode={barcodeString}
						data-name={b64EncodeUnicode(item.product_name || '')}
						data-code={item.default_code || ''}
						data-qty={item.qty_uom}
						key={`${product.line_id}_${index}`}>
						<div className='image_holder'>
							<Lightbox key={product.line_id}>
								<img src={odoo + item.quote_default_code} alt='product' />
							</Lightbox>
						</div>
						{item.additional_images && item.additional_images.length > 0 && (
							<div className='additionalimages__container'>
								<Lightbox key={currentIndex} style={{ display: 'block' }}>
									<img
										src={`data:image/jpeg;base64, ${item.additional_images[currentIndex]}`}
										alt={`Product ${currentIndex + 1}`}
									/>
								</Lightbox>
								{item.additional_images.length > 1 && (
									<div className='navigation-buttons'>
										<button onClick={this.prevImage} className='prev-button'>
											&lt;
										</button>
										<button onClick={this.nextImage} className='next-button'>
											&gt;
										</button>
									</div>
								)}
							</div>
						)}
						<div className='product_details'>
							<h4>
								{item.name}
								<span className='product_details__codes'>
									{item.default_code && (
										<div className='default_code' data-code={item.default_code}>
											<label>SKU:</label> [{item.default_code}]
										</div>
									)}
									{showBarcodeInPackingZone && item.barcode && (
										<div className='product_details__barcode'>
											<label>EAN:</label> [{item.barcode}]
										</div>
									)}
								</span>
							</h4>
							<div className='qty f_group'>
								<label>{intl.get('Ilość')}:</label>
								<div>
									<span data-qty={destinationQty}>{destinationQty}</span> {product.uom_name}
								</div>
							</div>
						</div>

						<div className='smaller-counter-wrapper'>
							<span className='smaller'>
								{product_uom_qty} x {item.qty_uom} = {destinationQty} {product.uom_name}
							</span>

							{scan_bundle_element_as_single_qty && (
								<span
									className='smaller counter'
									data-count='0'
									data-qty-uom={destinationQty}
									data-destination={destinationQty}>
									<span className='current-count'>0</span> / {destinationQty}
								</span>
							)}
						</div>
						<div className='checkbox-wrapper'>
							<div
								data-code-barcode={barcodeString}
								className={`checkbox multiproduct${
									['click', 'scan_click'].includes(product_confirmation_method) ? ' clickable' : ''
								}`}
								data-bundle-item-qty={item.qty_uom}
								onClick={event =>
									handleBundleCheckboxClick(
										event,
										item,
										parent,
										scan_bundle_element_as_single_qty,
										bundle_select,
										toggleConfirmButton
									)
								}>
								<Check className='check' />
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default BundleItemListExtended;
